import { useSyncExternalStore } from "react";

/**
 * Petit store global pour la bulle de chat « Parler à un conseiller ».
 * Permet d'ouvrir le widget depuis n'importe où (carte hub, escalade
 * assistant…) sans contexte React.
 */
let open = false;
let seedText = "";
const subs = new Set<() => void>();

function emit() {
  subs.forEach((f) => f());
}

/** Ouvre la bulle ; `seed` pré-remplit éventuellement le champ de message. */
export function openConseillerChat(seed?: string) {
  seedText = seed ?? "";
  if (!open) {
    open = true;
    emit();
  }
}

/** Message de pré-remplissage à la première ouverture (consommé une fois). */
export function consumeConseillerSeed(): string {
  const s = seedText;
  seedText = "";
  return s;
}
export function closeConseillerChat() {
  if (open) {
    open = false;
    emit();
  }
}

export function useConseillerChatOpen(): boolean {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb);
      return () => subs.delete(cb);
    },
    () => open,
    () => false,
  );
}
